/* eslint-disable no-underscore-dangle */
import { useEffect, useState } from 'react';
import { eventBus } from '../../../utils';

export default () => {
  const [state, _setState] = useState({
    canvas: null,
    editStyle: [],
    styleEdited: {},
    editText: {},
  });
  const setState = (obj) => _setState((_state) => ({ ..._state, ...obj }));

  const initCanvas = (canvas) => setState({ canvas });
  const handleStyleEdited = (styleEdited) => setState({ styleEdited });
  const onEditText = (contentEdit) => setState({ contentEdit });

  const onSelectionChanged = (e) => {
    const editText = e.target;
    const editStyle = editText.getSelectionStyles(editText.selectionStart, editText.selectionEnd, true);
    eventBus.emit('on-change-edit-text', { editText: e.target, editStyle });
    setState({ editStyle, editText });
  };

  useEffect(() => {
    const { editText, styleEdited, canvas } = state;
    if (!canvas || !editText) return;
    const object = state.canvas.getActiveObject();
    eventBus.emit('handle-setting', object, editText, styleEdited);
  }, [state.styleEdited]);

  useEffect(() => {
    eventBus.on('on-edit-text', onEditText);
    eventBus.on('set-style-edited', handleStyleEdited);
    return () => {
      eventBus.off('on-edit-text', onEditText);
      eventBus.off('set-style-edited', handleStyleEdited);
    };
  }, [state.styleEdited, state.editText, state.editStyle]);

  return {
    onSelectionChanged,
    initCanvas,
    editStyle: state.editStyle,
    editText: state.editText,
  };
};
